import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment.prod';
import { UtilitiesService } from './../../core/services/utilities.service';
import { API_URL } from './../enums/api-enums';
import { RequestOption } from './../model/common.model';
import { SingleResponse } from './../model/restful-api.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  baseURL = environment.portalURL;
  constructor(
    private util: UtilitiesService
  ) { }

  getData(requestOption: RequestOption, search, role): Observable<SingleResponse<any>> {
    let params = new HttpParams();
    if (search) {
      params = params.append('searchKey', search);
    }
    if (role) {
      params = params.append('role', role);
    }
    if (requestOption.pagingOptions.sort.sortBy && requestOption.pagingOptions.sort.sortOrder) {
      params = params.append('sortBy', requestOption.pagingOptions.sort.sortBy);
      params = params.append('sortDirection', requestOption.pagingOptions.sort.sortOrder);
    }
    params = params.append('size', requestOption.pagingOptions.size.toString());
    params = params.append('page', requestOption.pagingOptions.number.toString());
    return this.util.req.httpGet<SingleResponse<any>>(`${this.baseURL + API_URL.ROLE_MANAGEMENT}?${params}`);
  }

  getUserById(id): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseURL + API_URL.ROLE_MANAGEMENT + '/' + id);
  }

  changeActive(model): Observable<SingleResponse<any>> {
    return this.util.req.httpPut(`${this.baseURL + API_URL.ROLE_MANAGEMENT}/activate`, model);
  }

  checkSSO(sso): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseURL + API_URL.ROLE_MANAGEMENT + '/search?sso=' + sso);
  }

  addRole(model) {
    return this.util.req.httpPost(this.baseURL + API_URL.ROLE_MANAGEMENT, model);
  }

  updateRole(model) {
    return this.util.req.httpPut(this.baseURL + API_URL.ROLE_MANAGEMENT, model);
  }

  deleteRole(id) {
    return this.util.req.httpDelete(this.baseURL + API_URL.ROLE_MANAGEMENT + '/' + id);
  }
}
